import * as Redux from 'redux'
import * as Form from '../../components/form'
import * as Request from '../../request'
import * as Constants from './constants'
import * as Types from './types'

const initialViewState: Types.IsValidating = {
  isValidating: false,
}

const initialFormValues: Types.FormFields = {
  confirm_password: '',
  confirmation_code: '',
  new_password: '',
  username: '',
}

const viewReducer = (state: Types.IsValidating = initialViewState, action: any) => {
  switch (action.type) {
    case Request.requestConstant(Constants.CONFIRM_FORGOT_PASSWORD):
    case Request.requestConstant(Constants.FIRST_LOGIN):
      return {
        ...state,
        isValidating: true,
      }
    case Request.successConstant(Constants.CONFIRM_FORGOT_PASSWORD):
    case Request.errorConstant(Constants.CONFIRM_FORGOT_PASSWORD):
    case Request.successConstant(Constants.FIRST_LOGIN):
    case Request.errorConstant(Constants.FIRST_LOGIN):
      return {
        ...state,
        isValidating: false,
      }
    default:
      return state
  }
}

export const reducer = Redux.combineReducers({
  form: Form.createReducer(Constants.UPDATE_RESET_PASSWORD_FIELD, initialFormValues),
  view: viewReducer,
})



// WEBPACK FOOTER //
// ./src/pages/reset-password/reducer.ts